/**
 * `cn` — compose React `className` values with deduplication.
 *
 * Joins any mix of strings, falsy values, arrays, and objects via `clsx`,
 * then resolves Tailwind utility conflicts via `tailwind-merge` so the last
 * conflicting class wins. Works correctly even when a consumer does not use
 * Tailwind — non-Tailwind class names pass through untouched.
 *
 * Named after its concept (class-name composition). Re-exported as `cn` for
 * call-site brevity, matching the shadcn / Tailwind community convention.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: readonly ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export type { ClassValue };
